import { isEmpty } from 'lodash';
import { handleActions } from 'redux-actions';
import {
  FETCH_PUBLISHER_CATEGORIES,
  LOAD_PUBLISHER_CATEGORIES,
  LOAD_PUBLISHER_CATEGORY_INFO,
  CREATE_PUBLISHER_CATEGORY,
  CREATE_PUBLISHER_CATEGORY_SUCCESS,
  CREATE_PUBLISHER_CATEGORY_FAIL,
  LOAD_SOUNDCASTS_PUBLISHER_CATEGORIES,
  UPDATE_SOUNDCAST_PUBLISHER_CATEGORY,
  UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_SUCCESS,
  UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_FAIL,
  UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE,
  UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE_SUCCESS,
  UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE_FAIL,
} from '../actions/types';
import { updateTagAsFeatured } from '../routines/publisher';

const categories = handleActions(
  {
    [LOAD_PUBLISHER_CATEGORIES]: (state, action) => ({
      ...state,
      tags: action.payload,
      loading: false,
    }),
    [LOAD_PUBLISHER_CATEGORY_INFO]: (state, action) =>
      isEmpty(action.payload)
        ? state
        : {
            ...state,
            byId: { ...state.byId, [`${action.payload.id}`]: action.payload.Soundcasts },
          },
    [CREATE_PUBLISHER_CATEGORY]: (state, action) =>
      isEmpty(action.payload) ? state : { ...state, create: { loading: true } },
    [CREATE_PUBLISHER_CATEGORY_SUCCESS]: state => ({ ...state, create: { loading: false } }),
    [CREATE_PUBLISHER_CATEGORY_FAIL]: (state, action) =>
      isEmpty(action.payload)
        ? state
        : { ...state, create: { loading: false, error: action.payload.error } },
    [LOAD_SOUNDCASTS_PUBLISHER_CATEGORIES]: (state, action) =>
      isEmpty(action.payload) ? state : { ...state, ...action.payload },
    [UPDATE_SOUNDCAST_PUBLISHER_CATEGORY]: state => ({
      ...state,
      editById: { loading: true, error: '' },
    }),
    [UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_SUCCESS]: state => ({
      ...state,
      editById: { loading: false, error: '' },
    }),
    [UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_FAIL]: (state, action) => ({
      ...state,
      editById: { loading: false, error: action.payload.error },
    }),
    [UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE]: state => ({
      ...state,
      editTitleById: { loading: false, error: '' },
    }),
    [UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE_SUCCESS]: (state) => ({
      ...state,
      editTitleById: { loading: false, error: '' },
    }),
    [UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE_FAIL]: (state, action) => ({
      ...state,
      editTitleById: { loading: false, error: action.payload.error }
    }),
    [updateTagAsFeatured.TRIGGER]: (state) => ({
      ...state,
      loading: false,
      updateFeatured: { error: '' }
    }),
    [updateTagAsFeatured.SUCCESS]: (state) => ({
      ...state,
      loading: false,
      updateFeatured: { error: '' }
    }),
    [updateTagAsFeatured.FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      updateFeatured: { error: action.payload.error }
    })
  },
  {
    loading: true,
    tags: [],
    byId: {},
    individuals: [],
    bundles: [],
    editById: {
      loading: false,
      error: '',
    },
    updateFeatured: {
      loading: false,
      error: '',
    },
    create: {
      loading: false,
      error: '',
    },
    editTitleById: {
      loading: false,
      error: '',
    }
  }
);

export default categories;
